export default "__VITE_PUBLIC_ASSET__fb207657__"